import { render, staticRenderFns } from "./RequestFeedback.vue?vue&type=template&id=3ccad831&scoped=true"
import script from "./RequestFeedback.vue?vue&type=script&lang=js"
export * from "./RequestFeedback.vue?vue&type=script&lang=js"
import style0 from "./RequestFeedback.vue?vue&type=style&index=0&id=3ccad831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccad831",
  null
  
)

export default component.exports